module.exports = __webpack_public_path__ + "static/media/once.85c851f6.jpg";